import { FC } from 'react';

import { useSetRecoilState } from 'recoil';

import {
  AccountDateType,
  AccountDetailType,
} from '@shared/api/needAccount/needAccount.interface';
import { Button } from '@shared/components/Button';
import { simpleOpenAtomFamily } from '@shared/state/atom';
import { useId } from 'react-id-generator';

import { AgencyAdminAccountDetailModal } from './AgencyAdminAccountDetailModal';

interface Props {
  year: number;
  month: number;
  type?: AccountDetailType;
  dateType?: AccountDateType;
}

export const AgencyAdminAccountDetailModalButton: FC<Props> =
  function AgencyAdminAccountDetailModalButton({
    year,
    month,
    type = 'need-account',
    dateType,
  }: Props) {
    const [id] = useId(1, 'agencyAdminDetailModalButton');

    const openId = `${id}`;

    const setOpen = useSetRecoilState(simpleOpenAtomFamily(openId));
    return (
      <div>
        <Button
          onClick={() => {
            setOpen(true);
          }}
        >
          상세보기
        </Button>
        <AgencyAdminAccountDetailModal
          openId={openId}
          year={year}
          month={month}
          type={type}
          dateType={dateType}
        />
      </div>
    );
  };
